import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type GenerateMyCalendarLinkMutationVariables = {};


export type GenerateMyCalendarLinkMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'generateMyCalendarLink'>
);

export type AddSignatureMutationVariables = {
  input: Types.Scalars['String']
};


export type AddSignatureMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'addSignature'>
);

export const GenerateMyCalendarLinkDocument = gql`
    mutation generateMyCalendarLink {
  generateMyCalendarLink
}
    `;
export type GenerateMyCalendarLinkMutationFn = ApolloReactCommon.MutationFunction<GenerateMyCalendarLinkMutation, GenerateMyCalendarLinkMutationVariables>;

    export function useGenerateMyCalendarLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateMyCalendarLinkMutation, GenerateMyCalendarLinkMutationVariables>) {
      return ApolloReactHooks.useMutation<GenerateMyCalendarLinkMutation, GenerateMyCalendarLinkMutationVariables>(GenerateMyCalendarLinkDocument, baseOptions);
    };
export type GenerateMyCalendarLinkMutationHookResult = ReturnType<typeof useGenerateMyCalendarLinkMutation>;
export type GenerateMyCalendarLinkMutationResult = ApolloReactCommon.MutationResult<GenerateMyCalendarLinkMutation>;
export type GenerateMyCalendarLinkMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateMyCalendarLinkMutation, GenerateMyCalendarLinkMutationVariables>;
export const AddSignatureDocument = gql`
    mutation AddSignature($input: String!) {
  addSignature(input: $input)
}
    `;
export type AddSignatureMutationFn = ApolloReactCommon.MutationFunction<AddSignatureMutation, AddSignatureMutationVariables>;

    export function useAddSignatureMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddSignatureMutation, AddSignatureMutationVariables>) {
      return ApolloReactHooks.useMutation<AddSignatureMutation, AddSignatureMutationVariables>(AddSignatureDocument, baseOptions);
    };
export type AddSignatureMutationHookResult = ReturnType<typeof useAddSignatureMutation>;
export type AddSignatureMutationResult = ApolloReactCommon.MutationResult<AddSignatureMutation>;
export type AddSignatureMutationOptions = ApolloReactCommon.BaseMutationOptions<AddSignatureMutation, AddSignatureMutationVariables>;